import React, { useEffect, useRef, useState } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import ModalUmum from "../../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";
import * as XLSX from "xlsx";
import moment from "moment";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';

function ExpMember() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [getDataSuccess, setGetDataSuccess] = useState(false);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [filterActive, setFilterActive] = useState();
  const [filterAllSuccess, setFilterAllSuccess] = useState("all");
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  let componentRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [idUser, setIdUser] = useState();
  const [dataSelect, setDataSelect] = useState('Expired Today')
  const [dataExpLog, setDataExpLog] = useState([])
  const [columnActionHide, setColumnActionHide] = useState(false)
  const [autoCompleteExpLog, setAutoCompleteExpLog] = useState([])

  const options = [
  { value: 'Expired Today', label: 'Expired Today' },
  { value: 'Expired Tomorrow', label: 'Expired Tomorrow' },
  { value: 'Expired Log', label: 'Expired Log' }
]

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/users");
    const restData = result.data.data;
    delExpired(result.data.data);
    const dataActive = [];
    restData.forEach((item) => {
      if (item.active === true) {
        dataActive.push(item);
      }
    });
    setData(dataActive);
    //search auto complit
    const name = dataActive.map((value) => value.name);
    const email = dataActive.map((value) => value.email);
    const qrcode = dataActive.map((value) => value.qr);
    setAutoComplete(name.concat(email, qrcode));
    setGetDataSuccess(true);

    handleFilterExp()
  };

  const getDataExpLog = async () => {
    const result = await axios.get("https://mobile.amospa.com/explog");
    setDataExpLog(result?.data?.data?.reverse())
    //search auto complit
    const name = result?.data?.data?.map((value) => value.name);
    const email = result?.data?.data?.map((value) => value.email);
    const qrcode = result?.data?.data?.map((value) => value.qr);
    setAutoCompleteExpLog(name.concat(email, qrcode));
  };

  const handleFilterExp = async()=>{
    let arr = []

    if (dataSelect == 'Expired Log') {
      setColumnActionHide(true)
      dataExpLog.forEach(element => {

        arr.push(element)

        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(arr.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(arr.length / itemsPerPage));
        setFilterActive(arr)
      });
    }

    if (dataSelect !== 'Expired Log') {      
      setColumnActionHide(false)

      data.forEach(element => {
        if (dataSelect == 'Expired Today' && moment(element?.expired).parseZone().format('DD/MM/YYYY') == 
        moment(new Date()).parseZone().format('DD/MM/YYYY')) {
          arr.push(element)
        }
  
        if (dataSelect == 'Expired Tomorrow' && 
        moment(element?.expired).parseZone().format('DD/MM/YYYY') == moment().add(1, 'days').parseZone().format('DD/MM/YYYY')) {
          arr.push(element)
        }
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(arr.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(arr.length / itemsPerPage));
        setFilterActive(arr)
      });
    }


  }

  const handleNonActive = (id) => {
    setIdUser(id);
    setModalShow(true);
  };

  const getDataById = async (id) => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    return result;
  };

  //Handle Next
  const handleNext = async () => {
    const result = await getDataById(idUser);
    const dataUpdate = result.data.data[0];
    const data = new FormData();
    data.append("name", dataUpdate.name);
    data.append("phone", dataUpdate.phone);
    data.append("email", dataUpdate.email);
    data.append("birthday", dataUpdate.birthday);
    data.append("since", dataUpdate.since);
    data.append("expired", dataUpdate.expired);
    data.append("active", false);
    data.append("password", dataUpdate.password);
    data.append("gender", dataUpdate.gender);
    data.append("point", dataUpdate.point);

    await axios.put(`https://mobile.amospa.com/users/${idUser}`, data);
    setModalShow(false);
    await handlePostExpLog(idUser)
    window.location.reload()
  };

  //handle otomatis expired on-active
  const delExpired = (dataUser) => {
    let today = new Date();
    dataUser.forEach(async (item) => {
      let exp = new Date(item.expired);
      if (today.getFullYear() > exp.getFullYear()) {
        // await handlePostExpLog(item.id)
        await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
          active: false,
        });
      }

      if (exp.getFullYear() === today.getFullYear()) {
        if (today.getMonth() + 1 > exp.getMonth() + 1) {
          // await handlePostExpLog(item.id)
          await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
            active: false,
          });
        } else if (today.getMonth() + 1 === exp.getMonth() + 1) {
          if (today.getDate() > exp.getDate()) {
            // await handlePostExpLog(item.id)
           await axios.put(
              `https://mobile.amospa.com/users/${item.id}`,
              {
                active: false,
              }
            );
          }
        }
      }
    });
  };

  const handlePostExpLog = async(id)=>{
    if (id) {      
      const result = await getDataById(id);
      const dataUpdate = result.data.data[0];

      await axios.post(
        `https://mobile.amospa.com/explog`,
        {
          qr:dataUpdate.qr,
          userid:id,
          name:dataUpdate.name,
          phone:dataUpdate.phone,
          email:dataUpdate.email,
          since:dataUpdate.since,
          expired:dataUpdate.expired
        }
      );
    }

  }

useEffect(()=>{
  getDataExpLog()
},[])

  useEffect(() => {
    getData();
  }, [itemOffset, itemsPerPage, modalShow]);

  //Handle search
  const keys = ["name", "qr", "email"];
  const handleSearch = () => {
    if (dataSelect !== 'Expired Log') {      
      return search
        ? data.filter((item) => keys.some((key) => item[key].includes(search)))
        : false;
    }

    if (dataSelect == 'Expired Log') {      
      return search
        ? dataExpLog.filter((item) => keys.some((key) => item[key].includes(search)))
        : false;
    }
  };

  const showData = filterActive ? filterActive : currentItems;
  const member = handleSearch();
  const dataTable = member ? member : showData;

  const clickLog = (id) => {
    window.localStorage.setItem("logId", JSON.stringify(id));
    window.localStorage.setItem("expLog", JSON.stringify(true));
    navigate("/homepage/members/log/");
  };

  //pagination
  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  //Header csv
  const headers = [
    { label: "QR Code", key: "qr" },
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Member Since", key: "since" },
    { label: "Member Expired", key: "expired" },
  ];

  //XLSX
  const handleExportXlsx = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataTable);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "Member.xlsx");
  };


  return (
    <div className="member-list">
      <div className="member-list-header pb-4">
        <span className="d-flex align-items-center ms-1">
            <Select
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: '2px solid #FFD700',
              width:'250px',
              outline:'#FFD700',
              boxShadow:'none'
            }),
          }}
            options={options} onChange={(e)=>setDataSelect(e.value)}/>
            <Button variant="warning" className="ms-1" onClick={handleFilterExp}>Filter</Button>
        </span>
        <span className="d-flex">
          <button
            onClick={handleExportXlsx}
            className="btn text-decoration me-1"
            style={{
              background: "#FFD700",
              color: "black",
              outline: "none",
            }}
          >
            XLSX
          </button>
          <CSVLink
            data={dataTable}
            headers={headers}
            filename="Member AMO"
            className="btn text-decoration-none me-1"
            separator={";"}
            style={{ background: "#FFD700" }}
          >
            CSV
          </CSVLink>
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  className="btn text-decoration me-1"
                  style={{
                    background: "#FFD700",
                    color: "black",
                  }}
                >
                  Print
                </button>
              );
            }}
            content={() => componentRef}
            documentTitle="new document"
            pageStyle="print"
            className="bg-success"
          />
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            {
              dataSelect !== 'Expired Log' ?
              <AutoComplete
                placeholder="Search . . ."
                id="rs-input"
                onChange={(e) => setsearch(e)}
                data={autoComplete}
              />:
              <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoCompleteExpLog}
            />
            }
          </span>
        </span>
      </div>
      <div ref={(el) => (componentRef = el)}>
        <Table striped bordered hover size="sm">
          <thead>
            <tr className="th-table">
              <th>QR Code</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Member Since</th>
              <th>Expired Date</th>
              {
                columnActionHide == false &&<th>Action</th>
              }
            </tr>
          </thead>
          <tbody>
            {
              columnActionHide == false ? 
              dataTable?.map((item, index) => {
                return (
                  <tr key={index} className="table-content">
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.qr}
                    </td>
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.name}
                    </td>
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.phone}
                    </td>
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.email}
                    </td>
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {moment(item.since).parseZone().format('DD-MM-YYYY')}
                    </td>
                    <td
                      onClick={() => clickLog(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {moment(item.expired).parseZone().format('DD-MM-YYYY')}
                    </td>
                  {
                  !columnActionHide &&
                    <td>
                      {" "}
                      <button
                        className="btn-staffid bg-danger w-100 py-2"
                        style={{ width: "70px", borderRadius: "10px" }}
                        onClick={() => handleNonActive(item.id)}
                      >
                        Stop Member
                      </button>
                    </td>
                  }
                  </tr>
                );
              }):
              dataTable?.map((item, index) => {
                return (
                  <tr key={index} className="table-content"
                  onClick={() => clickLog(parseInt(item.userid))}
                  style={{ cursor: "pointer" }}>
                    <td>
                      {item.qr}
                    </td>
                    <td>
                      {item.name}
                    </td>
                    <td>
                      {item.phone}
                    </td>
                    <td>
                      {item.email}
                    </td>
                    <td>
                      {moment(item.since).parseZone().format('DD-MM-YYYY')}
                    </td>
                    <td>
                      {moment(item.expired).parseZone().format('DD-MM-YYYY')}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
      </div>
      
      {
      !filterActive &&
      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      }
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Non-Active Member ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default ExpMember;
